/* eslint-disable */
import { BlogPage } from '@/components/modules/pages/blog';
import { SCREEN_NAME } from '@/constants/analytics';
import { getHomeDescription, isSistaminuten, trackPage, url } from '@/helpers';
import { trackScreenShown } from '@/hooks/useTrackScreenShown';
import { __ } from '@/locale';
import { Helmet } from 'react-helmet';

const getSEO = () => {
  const title = __('seo.securityPolicyTitle');
  const description = getHomeDescription();
  const pageUrl = `${url.getBaseUrl()}articles/security-policy`;
  const imageUrl = url.getBaseImageUrl();
  const isNoIndex = isSistaminuten();

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={pageUrl} />

      <meta property="og:url" content={pageUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      {isNoIndex && <meta name="robots" content="noindex" />}
    </Helmet>
  );
};

const trackPageVisit = () => {
  trackPage();
  trackScreenShown({ screen_name: SCREEN_NAME.SECURITY_POLICY });
};

const SecurityPolicy = () => (
  <BlogPage
    pageId="3701"
    pageTitle={'Security Policy'}
    pageClassName="termsContent"
    seo={getSEO()}
    trackPage={trackPageVisit}
  />
);

export default SecurityPolicy;
